<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/reXuBF/tc-custom/9783958645592_IMGJPG_FrontCover_0.jpg?1703225433777" alt="This image is the cover for the book The Fifth Battalion Highland Light Infantry in the War 1914-1918, The World At War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Fifth Battalion Highland Light Infantry in the War 1914-1918, The World At War
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt from contents of book: ”Within a week our Brigade found itself at Dunfermline, and a few days later we were at Leven, with two companies on duty at the docks at Methil. The Leven companies did uninterrupted training, the Methil companies uninterrupted guards, and to the credit of the latter no one was drowned on these inky nights in the docks. It was there one night a small but gallant officer was going his rounds. One sentry was posted in mid-air on a coal chute, and to challenge persons approaching his post was one of his duties. On the approach of the officer there was no challenge, so to find the reason of this the officer climbed up the ladder and found the sentry, who explained he had seen something "right enuff, " but thought it was "one of them things they tie ships to"-in other words a bollard."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        F. L. Morrison
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?605cb43d